var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"post-item",attrs:{"href":_vm.post.href}},[_c('img',{attrs:{"src":_vm.post.src,"alt":_vm.post.title,"width":"100%","height":"auto"}}),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.post.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }